export const defaultMatch = <C>(criteria: C, value: C) => criteria === value;
